var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DragBox } from '../DragBox';
import { Grid, GridEvent } from "./Grid";
export var DraggableGridEvent;
(function (DraggableGridEvent) {
    DraggableGridEvent["ItemClicked"] = "ItemClicked";
    DraggableGridEvent["ItemHold"] = "ItemHold";
    DraggableGridEvent["Wheel"] = "Wheel";
})(DraggableGridEvent || (DraggableGridEvent = {}));
var DraggableGrid = (function (_super) {
    __extends(DraggableGrid, _super);
    function DraggableGrid(scene, draggableGridConfig) {
        var _this = this;
        var grid = new Grid(scene, {
            position: { x: 0, y: 0 },
            itemsInRow: draggableGridConfig.itemsInRow,
            horizontal: draggableGridConfig.horizontal,
            spacing: draggableGridConfig.spacing,
        });
        _this = _super.call(this, scene, {
            position: draggableGridConfig.position,
            width: draggableGridConfig.dimension.x,
            height: draggableGridConfig.dimension.y,
            content: grid,
            repositionToCenter: draggableGridConfig.repositionToCenter,
            reverseScrollForTrackpad: draggableGridConfig.reverseScrollForTrackpad,
            horizontal: draggableGridConfig.horizontal,
            margin: draggableGridConfig.margin,
            maskPosition: draggableGridConfig.maskPosition,
            debug: draggableGridConfig.debug,
        }) || this;
        _this.draggableGridConfig = draggableGridConfig;
        _this.grid = grid;
        _this.bindGridEventHandlers();
        return _this;
    }
    DraggableGrid.prototype.centerOnItem = function (index, duration) {
        if (duration === void 0) { duration = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var itemPos, draggableSpaceWidth, draggableSpaceHeight;
            return __generator(this, function (_a) {
                itemPos = this.grid.getItemLocalPosition(index);
                draggableSpaceWidth = this.getDraggableSpaceWidth();
                draggableSpaceHeight = this.getDraggableSpaceHeight();
                this.moveContentTo(this.isHorizontal() ?
                    (itemPos.x + this.getMarginLeft() - draggableSpaceWidth / 2) / (this.grid.width + this.getMarginLeft() + this.getMarginRight() - draggableSpaceWidth) :
                    (itemPos.y + this.getMarginTop() - draggableSpaceHeight / 2) / (this.grid.height + this.getMarginTop() + this.getMarginBottom() - draggableSpaceHeight), duration);
                return [2];
            });
        });
    };
    DraggableGrid.prototype.addItem = function (item) {
        this.grid.addItem(item);
        this.repositionContent();
    };
    DraggableGrid.prototype.setItemsInRow = function (count) {
        this.grid.setItemsInRow(count);
    };
    DraggableGrid.prototype.getAllItems = function () {
        return this.grid.getItems();
    };
    DraggableGrid.prototype.getItemOfId = function (id) {
        return this.grid.getItemOfId(id);
    };
    DraggableGrid.prototype.clearAllItems = function () {
        this.grid.clearAllItems();
    };
    DraggableGrid.prototype.removeItem = function (id) {
        return this.grid.removeItem(id);
    };
    DraggableGrid.prototype.isHorizontal = function () {
        return this.draggableGridConfig.horizontal;
    };
    DraggableGrid.prototype.getItemsInRowCount = function () {
        return this.draggableGridConfig.itemsInRow;
    };
    DraggableGrid.prototype.getGridSize = function () {
        return { x: this.grid.width, y: this.grid.height };
    };
    DraggableGrid.prototype.getGridPosition = function () {
        return { x: this.grid.x, y: this.grid.y };
    };
    DraggableGrid.prototype.getHorizontallyVisibleItemsInRowCount = function (itemWidth) {
        if (!this.draggableGridConfig.horizontal) {
            return this.draggableGridConfig.itemsInRow;
        }
        return Math.floor(this.getHorizontallyVisibleItemsInRowTotalValue(itemWidth));
    };
    DraggableGrid.prototype.getLastHorizontallyVisibleItemFraction = function (itemWidth) {
        if (!this.draggableGridConfig.horizontal) {
            return 0;
        }
        return this.getHorizontallyVisibleItemsInRowTotalValue(itemWidth) % 1;
    };
    DraggableGrid.prototype.getHorizontallyVisibleItemsInRowTotalValue = function (itemWidth) {
        var spacing = this.draggableGridConfig.spacing;
        var availableSpace = this.draggableGridConfig.dimension.x;
        return (spacing + availableSpace) / (spacing + itemWidth);
    };
    DraggableGrid.prototype.bindGridEventHandlers = function () {
        var _this = this;
        this.grid.on(GridEvent.ItemClicked, function (item) {
            _this.emit(DraggableGridEvent.ItemClicked, item);
        });
        this.grid.on(GridEvent.ItemHold, function (item) {
            _this.emit(DraggableGridEvent.ItemHold, item);
        });
        this.grid.on(GridEvent.Wheel, function (item) {
            _this.emit(DraggableGridEvent.Wheel, item);
        });
    };
    return DraggableGrid;
}(DragBox));
export { DraggableGrid };
